import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import MiscGrnModal from "../components/MiscGrnSupList";
import Time from "../components/time";
import { useParams, useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const AddMiscGRN = () => {
  useAuthRedirect();
  const { fld_purnumber } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]); 
  const branch = localStorage.getItem("branch");
  const user = localStorage.getItem("username");
  const [oldPoNumber, setPriNumber] = useState(null);  
  const [supplierNo, setSupplierNo] = useState(null);  
  const [poDate, setPoDate] = useState(null);  
const [freight, setFreight] = useState(""); 
const [poNumber, setPoNo] = useState(""); 
const [subDetails, setSubDetails] = useState({})
const [formData, setFormData] = useState({})
const [quantities, setQuantities] = useState({}); 
const navigate = useNavigate();

const canEntry = hasPermission("Branch office GRN", "entry");

useEffect(() => {
  const fetchPoNo = async () => {
    try {
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/miscgrn_no`);
      if (response.data.PoNo) {
        const NewPo = parseInt(response.data.PoNo, 10) || 0;
        setPoNo(NewPo.toString());
        setFormData(prevState => ({ ...prevState, PoNumber: NewPo.toString() }));
      }
    } catch (error) {
      console.error("Error fetching indent number:", error);
    }
  };
  fetchPoNo();
}, []);

const handleSelectItem = async (supplier) => {
    try {
      const trimmedSupplierCode = supplier.purchaseOrderHeader_suppliercode.trim();
  
      setSupplierNo(trimmedSupplierCode);
      setPriNumber(supplier.PurchaseOrderHeader_POnumber); 
      setPoDate(supplier.PurchaseOrderDetail_POdate)
  
      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/miscgrn_items", {
        params: {
          supplierCode: trimmedSupplierCode, 
          branch: branch.trim(),
        },
      });
  
      if (response.data.length > 0) {
        console.log(response.data);
        setSelectedItems(response.data);
      }
    } catch (error) {
      console.error("Error fetching supplier items:", error);
    }
  };
  
useEffect(() => {
    const fetchSupplierDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/purchaseOrder_supDetails?supplierCode=${supplierNo}`);
            const items = response.data.supDetails;
            const storeReqHeader1 = {
                supplierMaster_code: items[0].supplierMaster_code || "N/A",
                supplierMaster_name: items[0].supplierMaster_name || "N/A",
            };
            setSubDetails(storeReqHeader1);
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchSupplierDetails();
  }, [supplierNo]); 

  const handleQuantityChange = (index, value) => {
      if (value === "") {
        setQuantities({ ...quantities, [index]: "" }); 
        return;
      }
    
      const newValue = Number(value);
      const totalQuantity = selectedItems[index].grnDetail_poPendingQuantity;
    
      if (newValue > totalQuantity) {
        Swal.fire({
          icon: "warning",
          title: "Invalid Quantity!",
          text: `Accepted quantity cannot be more than ${totalQuantity}.`,
          confirmButtonText: "OK",
        });
    
        return; 
      }
    
      
      setQuantities({ ...quantities, [index]: newValue });
    };
    


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 🔹 Validate DC No
    if (!formData.dcNo || isNaN(formData.dcNo) || Number(formData.dcNo) <= 0) {
        Swal.fire("Error", "DC No must be a positive number", "error");
        return;
    }

    // 🔹 Validate DC Date
    if (!formData.dcDate) {
        Swal.fire("Error", "Please select DC Date", "error");
        return;
    }

    // 🔹 Validate Invoice No
    if (!formData.invoiceNo || isNaN(formData.invoiceNo) || Number(formData.invoiceNo) <= 0) {
        Swal.fire("Error", "Invoice No must be a positive number", "error");
        return;
    }

    // 🔹 Validate Invoice Date
    if (!formData.invoiceDate) {
        Swal.fire("Error", "Please select Invoice Date", "error");
        return;
    }

    // 🔹 Validate Items exist
    if (selectedItems.length === 0) {
        Swal.fire("Error", "Please add at least one item", "error");
        return;
    }

    // 🔹 Validate each item
   // 🔹 Validate each item's accepted quantity (accQty)
for (let [index, item] of selectedItems.entries()) {
    const accQty = Number(quantities[index] || 0); // accepted quantity
    if (isNaN(accQty) || accQty <= 0) {
        Swal.fire(
            "Error",
            `Accepted Quantity (accQty) for item ${item.purchaseOrderDetail_itemName} must be a positive number greater than 0`,
            "error"
        );
        return;
    }
}

    const payload = {
        branch: branch,
        grnNo: formData.PoNumber,
        user: user,
        scode: subDetails.supplierMaster_code,
        dcNo: formData.dcNo,
        dcDate: formData.dcDate,
        invoiceNo: formData.invoiceNo,
        invoiceDate: formData.invoiceDate,
        poNo: oldPoNumber,
        poDate: poDate,
        items: selectedItems.map((item, index) => {
            const acceptedQuantity = quantities[index] || 0;
            const totalQuantity = item.purchaseOrderDetail_orderedQuantity;
            const rejectedQuantity =
                acceptedQuantity === 0 ? 0 : totalQuantity - acceptedQuantity;
            return {
                itemCode: item.purchaseOrderDetail_itemCode,
                itemName: item.purchaseOrderDetail_itemName,
                itemUom: item.purchaseOrderDetail_uom,
                orderedQuantity: item.purchaseOrderDetail_orderedQuantity,
                price: item.purchaseOrderDetail_price,
                accQty: acceptedQuantity,
                rejQty: rejectedQuantity,
            };
        }),
    };

    try {
        Swal.fire({
            title: "Submitting...",
            text: "Please wait while we process your request.",
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            },
        });

        await axios.post("https://rfs2.infraconsoft.net.in/api/miscgrn_insert", payload);

        Swal.fire("Success", "Misc GRN added successfully", "success");
        setSelectedItems([]);
        navigate("/inventory/miscGrnView");
    } catch (error) {
        console.error("Error submitting form:", error);
        Swal.fire("Error", "Submission failed. Please try again.", "error");
    }
};


if (!canEntry) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <div className="back-div">
                                                              <h2 className="add-txt">Add Misc GRN</h2>
                                                              <Link to='/inventory/miscGrnView'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                                                              </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
          <div className="form-row">
              <div className="form-group">
                <label>GRN Number :</label>
                <input type="text" name="PoNumber" value={formData.PoNumber} readOnly />
              </div>
              <div className="form-group">
                <label>GRN Date :</label>
                <input type="date" name="endhrs" value={new Date().toISOString().split("T")[0]} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>PO No :</label>
                <input type="text" name="PoNumber" value={oldPoNumber} readOnly />
              </div>
              <div className="form-group">
                <label>PO Date :</label>
                <input type="text" name="endhrs" value={poDate ? new Date(poDate).toLocaleDateString("en-GB") : ""} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Supplier Code :</label>
                <input type="text" name="scode" value={subDetails.supplierMaster_code} />
              </div>
              <div className="form-group">
                <label>Supplier Name :</label>
                <input type="text" name="sname" value={subDetails.supplierMaster_name}/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>DC No :</label>
                <input type="text" name="dcNo" value={formData.dcNo}  onChange={handleChange}/>
              </div>
              <div className="form-group">
                <label>DC Date :</label>
                <input type="date" name="dcDate" value={formData.dcDate}  onChange={handleChange}/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Invoice No :</label>
                <input type="text" name="invoiceNo" value={formData.invoiceNo}  onChange={handleChange}/>
              </div>
              <div className="form-group">
                <label>Invoice Date :</label>
                <input type="date" name="invoiceDate" value={formData.invoiceDate}  onChange={handleChange}/>
              </div>
            </div>

            <div className="flex_buttons">
              <button type="button" className="button button-add" onClick={() => setShowModal(true)}>
                Add Item
              </button>
            </div>

            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th>UOM</th>
                    <th>Unit Price</th>
                    <th>P.O Pending Qty</th>
                    <th>DC Qty</th>
                    <th>Received Qty</th>
                    <th>Excess / Shortage</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedItems.length > 0 ? (
                    selectedItems.map((item, index) => {
                        const acceptedQuantity = quantities[index] || 0;
                        const totalQuantity = item.purchaseOrderDetail_orderedQuantity;
                        const rejectedQuantity = acceptedQuantity === 0 ? 0 : totalQuantity - acceptedQuantity;
                        // const acceptValue = acceptedQuantity * item.grnDetail_price;

                        
                      const itemValue = item.OrderedQuantity * item.SupplierWIDetail_Price;
                      const discountValue = itemValue * (item.SupplierWIDetail_DiscountPercentage / 100);
                      const pfValue = itemValue * (item.SupplierWIDetail_PfPercentage / 100);
                      const taxValue = itemValue * (item.SupplierWIDetail_CSTtax / 100);
                      const totalValue = itemValue + taxValue + pfValue - discountValue;

                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.purchaseOrderDetail_itemCode}</td>
                          <td>{item.purchaseOrderDetail_itemName}</td>
                          <td>{item.purchaseOrderDetail_uom}</td>
                          <td>{item.purchaseOrderDetail_price}</td>
                          <td>{item.purchaseOrderDetail_orderedQuantity}</td>
                          <td>{item.purchaseOrderDetail_orderedQuantity}</td>
                          <td><input
  type="number"
  value={quantities[index] === "" ? "" : quantities[index]} 
  min="0"
  max={item.grnDetail_poPendingQuantity} 
  onChange={(e) => handleQuantityChange(index, e.target.value)}
/></td>
<td>{rejectedQuantity}</td>

                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="10">No items added</td>
                    </tr>
                  )}
                </tbody>
              </table>

            </div>
            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Checkout
              </button>
            </div>
          </form>
        </div>
      </div>

      <MiscGrnModal showModal={showModal} closeModal={() => setShowModal(false)} branch={branch} onSelectItem={handleSelectItem} />
    </div>
  );
};

export default AddMiscGRN;
